import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import { Col, Nav, Row, Tab } from 'react-bootstrap'
import { toast } from 'react-toastify'
import Ribbon from '../../../../core/common/ribbon/ribbon'
import { useGetOpportunityDetailsbyIdQuery, useUpsertOpportunityDetailsMutation } from '../../../../services/EndPointsApis'
import ArchitecturalReviewTab from './ArchitecturalReviewTab'
import DescriptionTab from './DescriptionTab'
import PdmCheckInTab from './PdmCheckInTab'
import ScopeTab from './ScopeTab'
import SituationTab from './SituationTab'
import { constantsPermission } from '../../../../Config/Constants'
import { usePermission } from '../../../../core/hooks/PermissionHook'

const OpportunityDetails = ({ projectId, opportunityDetailsData, storeProjectId, projectLookups, showRibbon, setOpportunityData,refetchClientView, setOpportunityInitialValues }: any) => {
    // const { projectId } = useParams();

    const [updateProjectDetials, { data: updateProjectDetailData, isLoading, isSuccess, isError, error }] = useUpsertOpportunityDetailsMutation()
    const { data: opportunityByIdData, refetch } = useGetOpportunityDetailsbyIdQuery({ id: projectId || storeProjectId });
    const { view: viewOpportunity, edit: editOpportunity, create: createOpportunity } = usePermission(constantsPermission?.moduleId?.opportuityDetails);

    const initialValues = {
        projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
        opportunityDetailsDescription: {
            projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
            description: '',
            analysis: '',
            status: '',
            statusDetails: '',
            saleAmount: 0,
            leadSource: '',
            sourceDescription: '',
            adCode: '',
            jobName:'',
            jobType:{
                id: 0,
                value: ''
            }
        },
        opportunityDetailsPropertyAddress: {
            projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: '',
            zipCode: ''
        },
        opportunityDetailsSitution: {
            generalBackground: [
                {
                    projectId: projectId,
                    surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    name: '',
                    // surveyKey: 0,
                    surveyResultRevised: '',
                    surveyResultOriginal: '',
                    fieldType: '',
                    sectionId: 0,
                    subSectionId: 0
                }

            ],
            clientpastHomeRenvExp: [
                {
                    projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    name: '',
                    // surveyKey: 0,
                    surveyResultRevised: '0',
                    surveyResultOriginal: '0',
                    fieldType: '',
                    sectionId: 0,
                    subSectionId: 0
                }
            ],
            clientReasonForProject: [
                {
                    projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    name: '',
                    // surveyKey: 0,
                    surveyResultRevised: '0',
                    surveyResultOriginal: '0',
                    fieldType: '',
                    sectionId: 0,
                    subSectionId: 0
                }
            ],
            projectBackground: [
                {
                    projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    name: '',
                    // surveyKey: 0,
                    surveyResultRevised: '0',
                    surveyResultOriginal: '0',
                    fieldType: '',
                    sectionId: 0,
                    subSectionId: 0
                }
            ]
        },
        opportunityDetailsScopeDTO: {
            opportunityScop: [
                {
                    projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    name: '',
                    // surveyKey: 0,
                    surveyResultRevised: '0',
                    surveyResultOriginal: '0',
                    fieldType: '',
                    sectionId: 0,
                    subSectionId: 0
                }
            ],
            additionScope: [
                {
                    projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    name: '',
                    // surveyKey: 0,
                    surveyResultRevised: '0',
                    surveyResultOriginal: '0',
                    fieldType: '',
                    sectionId: 0,
                    subSectionId: 0
                }
            ],
            detailedScope: [
                {
                    projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    name: '',
                    // surveyKey: 0,
                    surveyResultRevised: '0',
                    surveyResultOriginal: '0',
                    fieldType: '',
                    sectionId: 0,
                    subSectionId: 0
                }
            ]
        },
        opportunityDetailsPDMCheckInDTO: {
            pdmCheckIn: [
                {
                    projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    name: '',
                    // surveyKey: 0,
                    surveyResultRevised: '0',
                    surveyResultOriginal: '0',
                    fieldType: '',
                    sectionId: 0,
                    subSectionId: 0
                }
            ]
        },
        opportunityDetailsArchitecturalReviewDTO: {
            architecturalReview: [
                {
                    projectId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    surveyMasterId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                    name: '',
                    // surveyKey: 0,
                    surveyResultRevised: '0',
                    surveyResultOriginal: '0',
                    fieldType: '',
                    sectionId: 0,
                    subSectionId: 0
                }
            ]
        },
        opportunityDetailsAppointment: {
            id: "410c9584-63db-4fef-99a1-7b72dbe32b6c",
            firstContactDate: "",
            firstAptDate: "",
            appointmentMaker: ""
        }
    }
    const [updateId, setUpdateId] = useState(0);

    useEffect(() => {
        if (opportunityByIdData?.result && Object.keys(opportunityByIdData?.result).length > 0) {
            setUpdateId(opportunityByIdData?.result?.id);
            formik.setValues({ ...opportunityByIdData?.result });
        } else {
            setUpdateId(0);
        }
    }, [opportunityByIdData]);

    const formik = useFormik({
        initialValues,
        // validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            updateProjectDetials(values)
        }
    })

    useEffect(() => {
        if (setOpportunityData) {
            setOpportunityInitialValues(initialValues)
            setOpportunityData(formik)
        }
    }, [setOpportunityData, formik.values])

    useEffect(() => {
        if (opportunityDetailsData) {
            formik.setValues({ ...opportunityDetailsData })
        }
    }, [opportunityDetailsData])

    useEffect(() => {
        if (projectId) {
            refetch()
        }
    }, [projectId])

    useEffect(() => {
        if (isSuccess) {
            toast.success(updateProjectDetailData?.message);
            refetch()
            refetchClientView()
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }

    },
        [isError, error]);

    return (
        <div className='row' >
            <div className='col-md-12'>
                {editOpportunity && 
                    <Ribbon
                        buttonText={isLoading ? 'Loading...' : 'Save'}
                        onClickbtn={() => formik.handleSubmit()}
                        buttonClass="btn ribbon-btn"
                        disabled={isLoading}
                    />
                }
                <Tab.Container id="left-tabs-example" defaultActiveKey="description">
                    <Row>
                        <Col sm={12}>
                            <div className='card'>
                                <div className='card-body p-2 card-css'>
                                    <div className='d-flex laign-items-center'>
                                        <Nav>
                                            <Nav.Item>
                                                <Nav.Link eventKey="description">Description</Nav.Link>
                                            </Nav.Item>
                                            {/* <Nav.Item>
                                                <Nav.Link eventKey="propertyAddress">Property Address</Nav.Link>
                                            </Nav.Item> */}
                                            <Nav.Item>
                                                <Nav.Link eventKey="situation">Situation</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="scope">Scope</Nav.Link>
                                            </Nav.Item>
                                            {/* <Nav.Item>
                                                <Nav.Link eventKey="appointmentDetails">Appointment Details</Nav.Link>
                                            </Nav.Item> */}
                                            <Nav.Item>
                                                <Nav.Link eventKey="PDMCheck-In">PDM Check-In</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="architecturalReview">Architectural Review</Nav.Link>
                                            </Nav.Item>
                                            {/* <Nav.Item>
                                                <Nav.Link eventKey="miscellaneous">Miscellaneous</Nav.Link>
                                            </Nav.Item> */}
                                        </Nav>
                                        {/* <button type='submit'
                                            onClick={(e) => {
                                                e.preventDefault();  // Optional: prevent default button behavior
                                                formik.handleSubmit(); // Trigger the Formik submit
                                            }}
                                            className='btn btn-primary px-3 ms-auto'>{isLoading ? 'Loading...' : 'Save'}</button> */}
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col sm={12} style={{ height: '599px', overflow: 'auto' }}>
                            <form onSubmit={formik.handleSubmit}>
                                <Tab.Content>
                                    <Tab.Pane eventKey="description"><DescriptionTab formik={formik} projectLookups={projectLookups} /></Tab.Pane>
                                    {/* <Tab.Pane eventKey="propertyAddress"><PropertyAddress /></Tab.Pane> */}
                                    <Tab.Pane eventKey="situation"><SituationTab formik={formik} projectLookups={projectLookups} /></Tab.Pane>
                                    <Tab.Pane eventKey="scope"><ScopeTab formik={formik} /></Tab.Pane>
                                    {/* <Tab.Pane eventKey="appointmentDetails"><AppointmentsTab /></Tab.Pane> */}
                                    <Tab.Pane eventKey="PDMCheck-In"><PdmCheckInTab formik={formik} /></Tab.Pane>
                                    <Tab.Pane eventKey="architecturalReview"><ArchitecturalReviewTab formik={formik} /></Tab.Pane>
                                    <Tab.Pane eventKey="miscellaneous">
                                        <div className="card">
                                            <div className="card-body">
                                                <center>
                                                    <h3 className='text-muted'>It looks like there's no data available</h3>
                                                </center>
                                            </div>
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </form>
                        </Col>
                    </Row>
                </Tab.Container>

            </div>
        </div>
    )
}

export default OpportunityDetails